/**
 * Operator attribution on legal pages and the contact page.
 * Default build names Pulse Real LLC. The India sentence is inside the
 * build-time branch so production minification drops it from flogpt.com.
 */
export default function SiteOperatorLine({ className }: { className?: string }) {
    if (import.meta.env.VITE_SITE_REGION === "in") {
        return (
            <p className={className}>
                floGPT India is operated by VDigit Solutions Private Limited, a subsidiary of Pulse Real LLC.
            </p>
        );
    }
    return <p className={className}>floGPT is operated by Pulse Real LLC.</p>;
}
